
<template>

    <section class="hidden"></section>

</template>

<script>

    export default {
        data () {
            return {

            }
        },
        created: function() {
        },
        methods: {

        },
        mounted: function() {

        }
    }

</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/pages/custom/Blank.vue